import { ResampleIntervals } from '~/types/resample.types';
import type { SeriesType } from '~/types/series.types';
import type { ChartEntity } from '~/types/chart-entity.types';
import { isCommodity, isFX } from '~/utils/entity/chart-entity';

export const isResampleOneDayOrGreater = (
  selectedResample: ResampleIntervals | undefined
): boolean => {
  if (!selectedResample) {
    return false;
  }

  const nonIntradayResamples = [
    ResampleIntervals.OneDay,
    ResampleIntervals.OneWeek,
    ResampleIntervals.OneMonth,
  ];

  return nonIntradayResamples.includes(selectedResample);
};

export const isChartTypeNotSupportedForFX = (
  entity: ChartEntity,
  selectedResample: ResampleIntervals | undefined,
  chartType: SeriesType
): boolean => {
  if (!isFX(entity)) {
    return false;
  }

  const isCandlestickOrBars = ['bars', 'candlestick'].includes(chartType);

  return isResampleOneDayOrGreater(selectedResample) && isCandlestickOrBars;
};

export const isChartTypeNotSupportedForCommodity = (
  entity: ChartEntity,
  selectedResample: ResampleIntervals | undefined,
  chartType: SeriesType
): boolean => {
  if (!isCommodity(entity)) {
    return false;
  }

  const isCandlestickOrBars = ['bars', 'candlestick'].includes(chartType);

  return isResampleOneDayOrGreater(selectedResample) && isCandlestickOrBars;
};
